import { ISPFieldConfig } from 'common/dynamic-form/model';

/**
 * Sort all configs by compare function
 *
 * @param configs
 * @param compareFn
 */
export function sortConfigs(
  configs: ISPFieldConfig[],
  compareFn: (a: ISPFieldConfig, b: ISPFieldConfig) => number,
): void {
  configs.sort(compareFn);

  configs.forEach(config => {
    if (config.fieldGroup) {
      sortConfigs(config.fieldGroup, compareFn);
    }
  });
}
